import API from "../api";

/** Fetch public branding (no auth needed) */
export const getPublicBranding = () =>
  API.get("/public/branding").then((r) => r.data);

/** Fetch full branding details (admin only) */
export const getAdminBranding = () =>
  API.get("/admin/branding").then((r) => r.data);

/** Update app name and tagline (admin only) */
export const updateBrandingText = (appName, tagline) =>
  API.post("/admin/branding", null, { params: { appName, tagline } }).then(
    (r) => r.data,
  );

/** Update public academy support contact (admin only, all license tiers) */
export const updateBrandingContact = (supportPhone, supportEmail) =>
  API.post("/admin/branding/contact", null, {
    params: { supportPhone, supportEmail },
  }).then((r) => r.data);

/** Upload logo file (admin only) */
export const uploadBrandingLogo = (file) => {
  const form = new FormData();
  form.append("file", file);
  return API.post("/admin/branding/logo", form, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then((r) => r.data);
};

/** Reset logo to default (admin only) */
export const deleteBrandingLogo = () => API.delete("/admin/branding/logo");

/** Absolute URL of the backend-served logo */
export const brandingLogoUrl = () => "/api/public/branding/logo";
